<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  [erroremessage]="erroremessage"
  (valueChange)="onChange($event)"
  (cancelChange)="cancel()"
  (valueChange)="onDynamicFormChanges($event)"
  hasfocus="Title"
  (submitChange)="save()"
  [noSubmit]="deactivateSave">
  <ng-container class="footer">
    <div *ngIf="haserror" class="alert alert-danger">
      <div [hidden]="!haserror">
        {{ erroremessage }}
      </div>
    </div>
  </ng-container>
</dynamic-form>
